'use strict';
import angular from 'angular';
import $ from 'jquery';
import moment from 'moment';
import _ from 'lodash';

angular.module('reporting.directives', [])
    .directive('reportFiledFilter', ['$rootScope', 'DateRangeService', 'ClusterService', function($rs, DateRangeService, ClusterService) {
        return {
            restrict: 'AE',
            replace: 'true',
            scope: {
                orderColumns: "=fieldSourceColumns",
                columns: "=fieldTargetColumns",
                fieldTitle: "@",
                fieldSourceTitle: "@",
                fieldTargetTitle: "@",
                filterColumns: "=filterSourceColumns",
                filters: "=filterTargetColumns",
                filterObj: "=targetFilterObj",
                filterTitle: "@",
                filterSourceTitle: "@",
                filterTargetTitle: "@"
            },
            controller: function($scope) {
                //console.log($scope);
                $scope.selectAllColumns = false;
                $scope.fieldTitle = angular.isDefined($scope.fieldTitle) ? $scope.fieldTitle : 'Add Order field as column';
                $scope.fieldSourceTitle = angular.isDefined($scope.fieldSourceTitle) ? $scope.fieldSourceTitle : 'Columns';
                $scope.fieldTargetTitle = angular.isDefined($scope.fieldTargetTitle) ? $scope.fieldTargetTitle : 'Selected Columns';

                $scope.filterTitle = angular.isDefined($scope.filterTitle) ? $scope.filterTitle : 'Add Order field as filter';
                $scope.filterSourceTitle = angular.isDefined($scope.filterSourceTitle) ? $scope.filterSourceTitle : 'Filter Columns';
                $scope.filterTargetTitle = angular.isDefined($scope.filterTargetTitle) ? $scope.filterTargetTitle : 'Selected Filters';
            },
            template: '<div> <div class="row">' + '<h4>{{fieldTitle}}</h4>' + '<div class="col-sm-12">' + '<div class="col-sm-5">' + '<div class="list-group">' + '<span class="list-group-item active"> <span class="pull-right"><small>select all</small> <input type="checkbox"  ng-model="selectAllColumns" ng-click="selectAllColumn()" /></span> <b>{{fieldSourceTitle}}</b> <small>(select to add)</small></span>' + '<div class="list-group-scroll"> <a ng-click="addColumn(order)" class="list-group-item" ng-repeat="order in orderColumns">{{order.name}}</a> </div>' + '</div>' + '</div> <div class="col-sm-2"></div> ' + '<div class="col-sm-5">' + '<div class="list-group">' + '<span class="list-group-item active sticky-column"><b>{{fieldTargetTitle}}</b> <small>(select to remove)</small> <a class="pull-right btn-primary btn-link" ng-click="removeAllColumns()"><strong>Remove all</strong></a> </span>' + '<div class="list-group-scroll"> <a ng-click="deleteColumn(column)" class="list-group-item" ng-repeat="column in columns">{{column.name}}</a></div>' + '</div> </div> </div>' + '</div>' + '<div class="row">' + '<h4>{{filterTitle}}</h4>' + '<div class="col-sm-12 ">' + '<div class="col-sm-5">' + '<div class="list-group">' + '<a class="list-group-item active sticky-column"><b>{{filterSourceTitle}}</b> <small>(select to add)</small></a>' + '<div class="list-group-scroll"> <a ng-click="addFilter(filter)" class="list-group-item" ng-repeat="filter in filterColumns">{{filter.name}}</a></div>' + '</div>' + '</div> <div class="col-sm-2"></div> ' + '<div class="col-sm-5"> <div class="list-group">' + '<a class="list-group-item active sticky-column"><b>{{filterTargetTitle}}</b> <small>(select to remove)</small></a>' + '<div class="list-group-scroll"> <div class="list-group-item" ng-repeat="filter in filters">' + ' <a ng-click="deleteFilter(filter)">{{filter.name}}</a>' + ' <select ng-if="filter.type == \'multi\'" class="form-control" multiple="true" ng-model="filterObj[filter.model]" ng-options="opt.id as opt.name for opt in filter.values" />' + ' <select ng-if="filter.type == \'single\'" class="form-control" ng-model="filterObj[filter.model]" ng-options="opt.id as opt.name for opt in filter.values" />' + ' <div class="input-group" ng-if="filter.type == \'date\'">' + '     <input style="width:200px" type="text" class="form-control" datepicker-popup="MMM dd, yyyy" ng-model="filterObj[filter.model]" is-open="Opened" datepicker-options="dateOptions" close-text="Close" datepicker-localdate />' + '     <span class="input-group-btn">' + '     <button type="button" class="btn btn-default btn-calendar" ng-click="Opened=true;$event.stopPropagation();"><i class="icon icon-calendar"></i></button>' + '     </span>' + ' </div>' + ' <div class="input-group" ng-if="filter.type == \'text\'">' + '     <input style="width:200px" type="text" class="form-control" ng-model="filterObj[filter.model]"/>' + ' </div>' + '</div> </div> </div> </div> </div>' + '</div>' + '</div>',
            link: function(scope, elem, attrs) {

                scope.selectAllColumn = function(){
                    if(scope.selectAllColumns === false){
                        for(var i = 0, len = scope.columns.length; i < len; i++ ){
                            scope.orderColumns.push(scope.columns[i]);
                        }
                        scope.columns = [];
                    }else if(scope.selectAllColumns === true){
                        for(var i = 0, len = scope.orderColumns.length; i < len; i++ ){
                            scope.columns.push(scope.orderColumns[i]);
                        }
                        scope.orderColumns = [];
                    }
                    scope.selectAllCheck();
                }
                scope.removeAllColumns = function(){
                    for(var i = 0, len = scope.columns.length; i < len; i++ ){
                        scope.orderColumns.push(scope.columns[i]);
                    }
                    scope.columns = [];
                }
                scope.selectAllCheck = function(){
                    if(scope.orderColumns.length > 0){
                        scope.selectAllColumns = false;
                    } else {
                        scope.selectAllColumns = true;
                    }
                }
                scope.addColumn = function(column) {
                    if (column) {
                        var index = scope.arrayHelpr(scope.columns, column.name);
                        var pos = scope.arrayHelpr(scope.orderColumns, column.name);

                        if (angular.isUndefined(index)) {
                            scope.columns.push(column);
                        }

                        if (pos > -1) {
                            scope.orderColumns.splice(pos, 1);
                        }
                    }
                    scope.selectAllCheck();
                }
                scope.deleteColumn = function(column) {
                    if (column) {
                        var pos = scope.arrayHelpr(scope.columns, column.name);
                        var index = scope.arrayHelpr(scope.orderColumns, column.name);

                        if (pos > -1) {
                            scope.columns.splice(pos, 1);
                        }

                        if (angular.isUndefined(index)) {
                            scope.orderColumns.push(column);
                        }
                    }
                    scope.selectAllCheck();
                }
                scope.addFilter = function(filter, ispopulateValue) {
                    if (filter) {
                        var index = scope.arrayHelpr(scope.filters, filter.name);
                        var pos = scope.arrayHelpr(scope.filterColumns, filter.name);
                        if (angular.isUndefined(index)) {
                            scope.filters.push(filter);
                            if (ispopulateValue) {
                                switch (filter.type) {
                                    case 'single':
                                        for (var i = 0, len = filter.values.length; i < len; i++) {
                                            if (filter.values[i].selected == 1) {
                                                scope.filterObj[filter.model] = filter.values[i].id;
                                            }
                                        }
                                        break;
                                    case 'multi':
                                        scope.filterObj[filter.model] = [];
                                        for (var i = 0, len = filter.values.length; i < len; i++) {
                                            if (filter.values[i].selected == 1) {
                                                scope.filterObj[filter.model].push(filter.values[i].id);
                                            }
                                        }
                                        break;
                                    case 'text':
                                        scope.filterObj[filter.model] = filter.selectedValue;
                                        break;
                                    case 'date':
                                        scope.filterObj[filter.model] = filter.selectedValue;
                                        break;

                                }
                            }

                        }
                        if (pos > -1) {
                            scope.filterColumns.splice(pos, 1);
                        }
                    }
                };
                scope.deleteFilter = function(filter) {
                    if (filter) {
                        var index = scope.arrayHelpr(scope.filters, filter.name);
                        var pos = scope.arrayHelpr(scope.filterColumns, filter.name);

                        if (angular.isUndefined(pos)) {
                            scope.filterColumns.push(filter);
                        }

                        if (index > -1) {
                            scope.filters.splice(index, 1);
                        }
                        delete scope.filterObj[filter.model];
                    }
                };
                scope.$on('loadTemplate',
                    function(options, template) {
                        scope.loadTemplate(template);
                    }
                );
                scope.loadTemplate = function(template) {
                    if (template) {
                        scope.columns = [];
                        scope.filters = [];
                        for (var i = 0, len = template.columns.length; i < len; i++) {
                            scope.addColumn(template.columns[i]);
                        }
                        for (var j = 0, size = template.filters.length; j < size; j++) {
                            scope.addFilter(template.filters[j], true);
                        }

                        var clusterArr = [];

                        //Pick the set of clusters associated with the template and populate
                        for (var k = 0, len = template.additionalSelections.length; k < len; k++) {
                            if (template.additionalSelections[k].clusterId) {
                                for (var m = 0; m < ClusterService.clusters.length; m++) {
                                    for (var l = 0, size = template.additionalSelections[k].clusterId.length; l < len; l++) {
                                        if (template.additionalSelections[k].clusterId[l] == ClusterService.clusters[m].id) {
                                            clusterArr.push(ClusterService.clusters[m]);
                                        };
                                    }
                                };
                            }
                            if (template.additionalSelections[k].startDate) {
                                DateRangeService.startDate = template.additionalSelections[k].startDate;
                            }
                            if (template.additionalSelections[k].endDate) {
                                DateRangeService.endDate = template.additionalSelections[k].endDate;
                            }
                        }

                        // For all Clusters
                        if (!clusterArr.length) {
                            clusterArr = ClusterService.clusters[0];
                        }else{
                            //Helper function to remove duplicates if any
                            clusterArr = _.uniqBy(clusterArr, function (e) {
                                return e.id;
                            });
                        }

                        ClusterService.clustersChangedInDirective(clusterArr);
                        $rs.$broadcast('clusterChange:reporting', clusterArr);
                        if (DateRangeService.startDate && DateRangeService.endDate) {
                            var options = {
                                "start": moment(DateRangeService.startDate).format("X"),
                                "end": moment(DateRangeService.endDate).format("X")
                            }
                            $rs.$broadcast('dateRangePicker:change', options);
                            $("input.daterange").data('daterangepicker').setStartDate(moment(DateRangeService.startDate).format("MMM DD, YYYY"));
                            $("input.daterange").data('daterangepicker').setEndDate(moment(DateRangeService.endDate).format("MMM DD, YYYY"));
                        }

                    } else {
                        var orderCols = scope.columns.slice();
                        var filterCols = scope.filters.slice();
                        for (var i = 0, len = orderCols.length; i < len; i++) {
                            scope.deleteColumn(orderCols[i]);
                        }
                        for (var j = 0, size = filterCols.length; j < size; j++) {
                            scope.deleteFilter(filterCols[j]);
                        }
                        scope.filterObj = {};
                    }
                }
                scope.arrayHelpr = function(arr, text) {
                    for (var i = 0, len = arr.length; i < len; i++) {
                        if (arr[i].name == text) {
                            return i;
                        }
                    }
                };
            }
        }
    }]);